module.exports = __webpack_public_path__ + "static/media/erinMock.2866c855.jpg";